import React, { createContext, useContext } from "react";
import { useQuery } from "seed/gql";

const NodesContext = createContext(undefined);

const useNodes = ({ checkContext = true } = {}) => {
  const context = useContext(NodesContext);
  if (!context) {
    if (checkContext)
      throw new Error("useNodes must be used within a NodesProvider");
    return { nodes: [], edges: [], annotations: [], reqNodes: { loaded: true }, reqEdges: { loaded: true }, reqAnnotations: { loaded: true } };
  }
  return context;
};

const NodesProvider = ({
  pageId,
  children,
}) => {
  const filterPage = (pageId ? `page.id=${pageId}` : "page.isDefault=True");
  // A retired node keeps its row so its execution history resolves, but it is no
  // longer part of the definition and the board must not draw it.
  const filterNodes = `(${filterPage} AND is_active=true)`;
  const reqNodes = useQuery(`{
      flowNodes {
        createdAt
        inputValues
        outputValues
        uiSettings
        isEnabled
        hasTestCases
        action { 
          name
          type
          isEditable
          inputStructure
          outputStructure
          uiSettings
          isAnnotation
          app { 
            name
            uiSettings
          }
        }
        isVerified
        rootName
        rootDescription
        rootSettings
        flow { name }
      }
    }`, filterNodes);

  const reqEdges = useQuery(`{
      flowEdges {
        type
        createdAt
        sourceName
        targetName
        source { }
        target { }
        flow { name }
      }
    }`, filterPage);

  const reqAnnotations = useQuery(`{
      flowAnnotations {
        createdAt
        inputValues
        uiSettings      
        action { 
          name
          type
          isEditable
          inputStructure
          outputStructure
          uiSettings
          isAnnotation
          app { 
            name
            uiSettings
          }
        }
        flow { name }
      }
    }`, filterPage);


  const nodes = reqNodes.data.flowNodes;
  const edges = reqEdges.data.flowEdges;
  const annotations = reqAnnotations.data.flowAnnotations;

  return (
    <NodesContext.Provider value={{ nodes, edges, annotations, reqNodes, reqEdges, reqAnnotations }}>
      {children}
    </NodesContext.Provider>
  );
};


export { NodesProvider, useNodes };